import styles from "@components/__templates__/RegisterInterestSuccessPage/RegisterInterestSuccessPage.module.scss";
import Grid from "@components/Grid/Grid";
import Link from "@components/Link/Link";
import clsx from "clsx";
import { useRouter } from "next/router";

export interface RegisterInterestSuccessPagePropsProps {
  successHeaderTitleText: string;
  successDescriptionText: string;
  returnToPreviousPageLinkText: string;
}

const RegisterInterestSuccessPage = (props: {
  content: RegisterInterestSuccessPagePropsProps;
}) => {
  const { content } = props;
  const {
    successHeaderTitleText,
    successDescriptionText,
    returnToPreviousPageLinkText,
  } = content;

  const router = useRouter();

  const isWindow = typeof window === "object";
  const urlParams = isWindow
    ? new URLSearchParams(window.location.search)
    : null;
  const returnToPreviousPageUrl = urlParams?.get("referPage");

  const returnToOriginalPage = () => {
    router.push(`${returnToPreviousPageUrl}`, undefined, {
      shallow: true,
    });
  };

  return (
    <div className="component-wrap">
      <Grid row>
        <Grid column sm={12}>
          <div className={clsx("component", styles["success-brochure"])}>
            <div className="wrapper">
              <Grid row>
                <Grid column sm={12} md={12} lg={12}>
                  <h1 className={clsx(styles["section-title"], styles.h2)}>
                    {successHeaderTitleText}
                  </h1>
                  <div className={styles["success-text"]}>
                    <p>{successDescriptionText}</p>
                  </div>
                </Grid>
              </Grid>
            </div>
            <div className={clsx(styles["links-wrapper"])}>
              <div className="wrapper">
                <Grid row>
                  <Grid column sm={12} md={12} lg={12}>
                    <div className={styles["userLink-section"]}>
                      {returnToPreviousPageUrl && (
                        <p>
                          <Link
                            href={`${returnToPreviousPageUrl}`}
                            onClick={returnToOriginalPage}
                          >
                            {returnToPreviousPageLinkText}
                          </Link>
                        </p>
                      )}
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default RegisterInterestSuccessPage;
